import React from "react";
import ReactDOM from "react-dom";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function EditLeaveRequestModal({
  closeModal,
  alert,
  requestType,
  getRequest,
  value,
}) {
  const addMonth = (num) => {
    let day = new Date();
    day.setDate(day.getDate() + num);
    return day;
  };
  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Edit Leave Request
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{
          request_type: value.request_type,
          start_date: new Date(value.start_date),
          end_date: new Date(value.end_date),
          id: value.id,
        }}
        onSubmit={(values) => {
          values.start_date = new Date( values.start_date.getTime() + Math.abs(values.start_date.getTimezoneOffset()*60000))
          values.end_date = new Date( values.end_date.getTime() + Math.abs(values.end_date.getTimezoneOffset()*60000))
          
          ApiService.post(
            `leave-requests/update-leave-request/${value.id}`,
            values
          ).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            getRequest();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form className="mt-2">
            <div className="form-group">
              <label>
                {" "}
                Leave Type<span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="request_type"
                name="request_type"
              >
                <option>--Select Leave type--</option>

                {requestType.map((leave, i) => (
                  <option value={leave.id} key={i}>
                    {leave.type}
                  </option>
                ))}
              </Field>
            </div>
            <label>
              {" "}
              Start Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={values.start_date}
                minDate={new Date()}
                // maxDate={addMonth(8)}
                showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="start_date"
                onChange={(date) => setFieldValue("start_date", date)}
              />
            </div>
            <label>
              {" "}
              End Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={values.end_date}
                minDate={new Date()}
                // maxDate={addMonth(8)}
                showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="end_date"
                onChange={(date) => setFieldValue("end_date", date)}
              />
            </div>

            <hr />

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/holidaymanagement/modal/edit_leave_request.js